module.exports = __webpack_public_path__ + "static/img/master.8625be4c.3ba89fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/master.8625be4c.png
// module id = kbOt
// module chunks = 1